<script>

import { testWebsocket } from '../page/troubleshooting.page.utils.mjs';

export default {
  methods: {},
  props: ["component"],
  translate25Context: 'troubleshooting',
  data() {
    return {
      status: 'pending',
    }
  },
  async mounted() {

    if (this.component.no_check) {
      this.status = 'unknown';
      return;
    }

    var urlMatch = this.component.host.match(/(.*\/\/[^\/]+)(\/.*)/);

    this.status = await testWebsocket(urlMatch[1] + ':' + this.component.port, urlMatch[2]) ? 'ok' : 'ko';
  }
};
</script>

<template>
  <div class="troubleshooting-websocket-status">
    <troubleshooting-page-status :status="status">
      <template #content>{{ component.host }} /
        {{ component.port }}</template></troubleshooting-page-status>

    <f-hint v-if="status == 'ko'" type="negative" icon="fa6-triangle-exclamation">
      <template #message>{{ $vt('Could not connect via websocket to {host} on port {port}. Please, contact your network administrator.', {host: component.host, port: component.port}) }}<br />
      </template>
    </f-hint>

    <f-hint v-if="component.no_check" type="notice" icon="fa6-triangle-exclamation">
      <template #message>{{ $vt('Check with your network administrator that port {port} is open on {host}.', {port: component.port, host: component.host}) }}<br />
      </template>
    </f-hint>
  </div>
</template>

<style lang="scss">
.troubleshooting-websocket-status {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>